export function stopPropagation(event: React.SyntheticEvent) {
  event.stopPropagation();
}
